<template>
  <div>
    <l-search>
      <l-form layout="inline" laba-width="70px">
        <l-form-item label="系统">
          <l-select
            v-model="appId"
            placeholder="请选择系统"
          >
            <l-select-option
              v-for="item in authAppList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.cnName }}
            </l-select-option>
          </l-select>
        </l-form-item>
      </l-form>
      <template slot="right">
        <l-button class="l-float-right" @click="resetForm">
          重置
        </l-button>
      </template>
    </l-search>

    <div>
      <div v-if="appId" class="l-text-right l-mb-10">
        <div class="form-row form-group">
          <div>
            <l-button
              v-show="submitData.isAdmin === 0"
              type="primary"
              class="l-mr-10"
              @click="globalAllResource"
            >
              所有权限
            </l-button>
            <l-button
              v-show="submitData.isAdmin === 0"
              type="plain"
              @click="globalReadResource"
            >
              所有只读
            </l-button>
            <span style="margin:0 10px;">是否拥有所有菜单:</span>
            <l-radio-group v-model="submitData.isAdmin">
              <l-radio :value="1">是</l-radio>
              <l-radio :value="0">否</l-radio>
            </l-radio-group>
            <l-button
              :loading="isSave"
              class="l-ml-30"
              type="primary"
              @click="save"
            >
              保存实例
            </l-button>
            <l-button
              v-show="!!$utils.getParam('appUserInstanceId') && submitData.isAdmin === 0"
              :loading="isResetInstance"
              @click="resetInstance"
            >
              重置实例
            </l-button>
          </div>
        </div>
      </div>
      <div v-show="submitData.isAdmin === 0" class="c-menu-tree">
        <l-tree
          v-if="isInit"
          ref="tree"
          :checked-keys="defaultCheckedKeys"
          :tree-data="treeData"
          :replace-fields="{children:'children', title:'name', key:'id'}"
          :default-expand-all="true"
          :block-node="true"
          :default-checked-keys="defaultCheckedKeys"
          checkable
          @check="checkChange"
        />
      </div>

      <!-- 当前选择的菜单资源树 -->
      <div v-show="submitData.isAdmin === 0" class="c-menu-tree_setting">
        <l-tree
          :tree-data="treeSelectData"
          :replace-fields="{children:'children', title:'name', key:'id'}"
          :default-expand-all="true"
          :block-node="true"
          @select="nodeClick"
        >
          <span
            slot="slotsTitle"
            slot-scope="{ dataRef }"
            class="custom-tree-node"
          >
            {{ dataRef.name }}
            <span
              v-if="dataRef.resources.length === 0 || dataRef.level === 1"
              style="font-size:12px;"
              class
            >(无需设置)</span>
            <span
              v-else-if="dataRef.menuResources.length === dataRef.resources.length"
              style="font-size:12px;"
              class="deep-green"
            >(所有权限)</span>
            <span
              v-else-if="dataRef.menuResources.length === 0"
              style="font-size:12px;"
              class="red"
            >(无权限)</span>
            <span
              v-else
              style="font-size:12px;"
              class="green"
            >(部分权限)</span>
          </span>
        </l-tree>
      </div>

      <!-- 资源关联 -->
      <div
        v-show="submitData.isAdmin === 0 && menu && Object.keys(menu).length > 0 && menu.resources.length > 0"
        style="display:inline-block;width:40%;vertical-align:top;"
        class="l-ml-20"
      >
        <div style="margin-bottom:10px;">
          <l-button type="primary" @click="allResource">所有</l-button>
          <l-button type="plain" class="l-ml-10" @click="readResource">只读</l-button>
        </div>
        <a-transfer
          :target-keys="menu.menuResources"
          :data-source="menuResources"
          :titles="['全部权限', '所选权限']"
          :render="item => item.name"
          @change="handleResourcesChange(menu, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AuthAppUserInstanceEdit',
  data() {
    return {
      id: null,
      searchFilter: {},
      appId: null,
      flatDeepTreeData: [],
      treeData: [],
      treeSelectData: [],
      checkMenuTreeData: [],

      menuResource: {},
      menuResources: [],
      isSave: false,
      isResetInstance: false,
      menu: {},
      submitData: {
        isAdmin: 0,
        id: 0,
        appId: 0,
        menuIds: []
      },
      isInit: false,
      defaultCheckedKeys: [] // 默认选中节点
    }
  },
  computed: {
    ...mapState({
      authAppList: state => state.auth.authAppList
    })
  },
  watch: {
    appId() {
      if (!this.appId) {
        return
      }
      this.resetData()
    }
  },
  mounted() {
    this.id = this.$utils.getParam('id')
    if (!this.id) {
      // this.$close(true)
      return this.$toPage('/auth-role/list')
    }
    this.resetForm()
    if (this.id) {
      this.getAuthRole()
    }
  },
  activated() {
    this.id = this.$utils.getParam('id')
    if (!this.id) {
      // this.$close(true)
      return this.$toPage('/auth-role/list')
    }
    this.resetForm()
    if (this.id) {
      this.getAuthRole()
    }
  },
  methods: {
    handleResourcesChange(menu, targetKeys) {
      menu.menuResources = targetKeys
    },
    async getAuthRole() {
      const data = await this.$store.dispatch('auth/getAuthRole', {
        id: this.id
      })
      this.appId = data.appId
      this.submitData = data
      this.submitData.menuList = this.submitData.menuList || []
      this.submitData.menuList.forEach(item => {
        item.oldResources = item.resources
      })
    },
    globalAllResource() {
      this.treeSelectData.forEach(item1 => {
        item1.children.forEach(item2 => {
          item2.children.forEach(item3 => {
            item3.menuResources = JSON.parse(JSON.stringify(item3.resources))
          })
        })
      })
    },
    globalReadResource() {
      this.treeSelectData.forEach(item1 => {
        item1.children.forEach(item2 => {
          item2.children.forEach(item3 => {
            item3.menuResources = []
            item3.resources.forEach(resourceId => {
              const r = this.menuResource[resourceId]
              if (r && r.type !== 2) {
                item3.menuResources.push(resourceId)
              }
            })
          })
        })
      })
    },
    readResource() {
      if (!this.menu) {
        return
      }
      this.menu.menuResources = []
      this.menuResources.forEach(item => {
        if (item.type !== 2) {
          this.menu.menuResources.push(item.id)
        }
      })
    },
    allResource() {
      if (!this.menu) {
        return
      }
      this.menu.menuResources = []
      this.menuResources.forEach(item => {
        this.menu.menuResources.push(item.id)
      })
    },
    nodeClick(keyList) {
      if (keyList.length !== 1) return
      let menu = this.checkMenuTreeData.find(menu => menu.id === keyList[0])
      if (!menu) return
      if (menu.id === -1) {
        menu = {}
      }
      this.menu = menu
      this.menuResources = []
      this.menu.resources.forEach(item => {
        this.menuResources.push(this.menuResource[item])
      })
    },
    checkMenuParentIdHandle(childrenMenuIdList) {
      const parentIdSet = new Set()
      let isErrorCount = 0
      childrenMenuIdList.forEach(item => {
        let menuId = item
        let findMenu
        do {
          if (isErrorCount > 50) {
            break
          }
          // eslint-disable-next-line no-loop-func
          findMenu = this.flatDeepTreeData.find(menu => menu.id === menuId)
          if (findMenu && findMenu.parentId) {
            parentIdSet.add(findMenu.parentId)
            menuId = findMenu.parentId
          }
          isErrorCount++
        } while (findMenu && findMenu.parentId)
      })
      const checkMenuParentIdList = Array.from(parentIdSet)
      if (isErrorCount >= 50) {
        return []
      } else {
        return checkMenuParentIdList
      }
    },
    checkChange(e) {
      if (!e) return
      const menuIdSet = new Set()

      if (e.checked) {
        e = e.checked
      }
      const menus = []
      const defaultCheckedKeys = []
      // 获取勾选节点
      if (e && e.length > 0) {
        e.forEach(item => {
          if (item !== -1) {
            menuIdSet.add(item)
            defaultCheckedKeys.push(item)
          }
        })
        const parentIdList = this.checkMenuParentIdHandle(e)
        parentIdList.forEach(item => {
          menuIdSet.add(item)
        })
        Array.from(menuIdSet).forEach(item => {
          // defaultCheckedKeys.push(item)
          menus.push({
            menuId: item,
            resources: ''
          })
        })
        this.defaultCheckedKeys = defaultCheckedKeys
        this.submitData.menus = menus
      }

      this.menu = {}
      if (e.length === 0) {
        this.treeSelectData = []
        return
      }
      let checkMenuTreeData = []
      // 将menuId数组转换为对应的menu数组
      menus.forEach(menu => {
        const findMenu = this.flatDeepTreeData.find(data => data.id === menu.menuId)
        if (!findMenu) return
        checkMenuTreeData.push(findMenu)
      })
      checkMenuTreeData = checkMenuTreeData.map(item => {
        // 复制数组元素，并且复制资源和清空children
        const obj = Object.assign({}, item)
        const findMenu = this.submitData.menuList.find(menu => menu.menuId === obj.id)
        if (findMenu && findMenu.resources) {
          obj.menuResources = findMenu.resources.replace(/^,/, '').replace(/,$/, '').split(',').map(item => Number(item))
        }
        obj.children = []
        return obj
      })
      const treeSelectData = []
      // 遍历选中的数组，按照parentId来拼接为树形
      checkMenuTreeData.forEach(menu => {
        if (menu.parentId) {
          const parentMenu = checkMenuTreeData.find(item => item.id === menu.parentId)
          if (parentMenu) {
            parentMenu.children.push(menu)
          }
        } else {
          treeSelectData.push(menu)
        }
      })
      this.checkMenuTreeData = checkMenuTreeData
      this.treeSelectData = treeSelectData
    },
    resetInstance() {
      this.$xyConfirm('确认是否重置实例，重置后修改的数据将无法恢复？', () => {
        this.isResetInstance = true
        this.resetData(() => {
          this.isResetInstance = false
        })
      })
    },
    initMenuResource(menus) {
      if (!menus || menus.length === 0) {
        return
      }
      menus.forEach(menu => {
        menu.resources = menu.resources || ''
        menu.scopedSlots = { title: 'slotsTitle' }
        menu.resources = menu.resources.replace(/^,/, '').replace(/,$/, '')
        if (menu.resources) {
          menu.resources = menu.resources.split(',')
          for (let i = 0; i < menu.resources.length; i++) {
            menu.resources[i] = Number(menu.resources[i])
          }
        } else {
          menu.resources = []
        }
        this.$set(menu, 'menuResources', [])
        this.initMenuResource(menu.children)
      })
    },
    setLevel(data, level, sort) {
      level = level || 0
      sort = sort || 0
      if (!data || data.length === 0) {
        return sort
      }
      data.forEach(item => {
        item.level = level
        if (level <= 1) {
          item.type = 3
        } else if (!item.type) {
          item.type = 1
        }
        item.appId = this.appId
        item.sort = sort++
        item.children = item.children || []
        sort = this.setLevel(item.children, level + 1, sort)
      })
      return sort
    },
    async resetData(cb) {
      if (this.submitData.menuList) {
        this.submitData.menuList.forEach(item => {
          item.resources = item.oldResources || ''
        })
      }
      this.menu = {}
      this.treeData = []
      let data = await this.$store.dispatch('auth/authMenuList', {
        appId: this.appId
      })
      data = data || []
      this.treeData = data
      this.flatDeepTreeData = this.$utils.flatDeep(data || [], 'children')
      this.treeData = [{
        id: -1,
        name: '全部菜单',
        children: this.treeData
      }]
      this.initMenuResource(this.treeData)
      this.setLevel(this.treeData)
      this.treeSelectData = []
      if (!this.id) {
        this.submitData = this.$options.data().submitData
      } else {
        this.setCheckedKeys()
      }
      this.getMenuResources(cb)
      this.isInit = true
    },
    setCheckedKeys() {
      this.$nextTick(() => {
        const ids = []
        if (this.submitData.menuList) {
          this.submitData.menuList.forEach(item => {
            // 过滤掉有子节点的
            const findMenu = this.flatDeepTreeData.find(data => data.id === item.menuId)
            if (!findMenu || (findMenu.children && findMenu.children.length > 0)) return
            ids.push(item.menuId)
          })
        }
        // TODO 默认选中节点
        this.defaultCheckedKeys = ids
        // 默认选中节点
        this.checkChange(ids)
        this.$nextTick(() => {
          if (this.submitData.menuList) {
            this.submitData.menuList.forEach(item => {
              item.oldResources = item.resources
              item.resources = ''
            })
          }
        })
      })
    },
    _getMenus(menus, data) {
      if (!data || data.length === 0) {
        return
      }
      data.forEach(item => {
        let r = item.menuResources || []
        r = r.join(',')
        if (r) {
          r = ',' + r + ','
        }
        menus.push({
          menuId: item.id,
          resources: r
        })
        this._getMenus(menus, item.children)
      })
    },
    async save() {
      this.isSave = true
      const menus = []
      this._getMenus(menus, this.treeSelectData)
      this.submitData.menus = menus
      try {
        await this.$store.dispatch('auth/authRoleSave', this.submitData)
        this.$toPage('/auth-role/list')
        this.isSave = false
      } catch (e) {
        this.isSave = false
      }
    },
    async getMenuResources(cb) {
      const data = await this.$store.dispatch('auth/authResourcesListForApp', {
        appId: this.appId
      })
      const resource = data || []
      this.menuResource = {}
      resource.forEach(item => {
        item.key = Number(item.id)
        this.menuResource[item.id] = item
      })
      cb && cb()
    },
    async resetForm() {
      await this.$store.dispatch('auth/authAppList')
    }
  }
}
</script>

<style lang="scss">
.lineThrough {
  text-decoration: line-through;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 10px;
}
.l-transfer__buttons {
  padding: 0 6px;
}
.l-transfer__button {
  border-radius: 50%;
  font-size: 0;
  min-width: 0;
  padding: 0;
  height: 34px;
  width: 34px;
  line-height: 34px;
}

.c-menu-tree {
  display: inline-block;
  vertical-align: top;
  min-width: 25%;
  background-color: #f2f5f6;
}
.c-menu-tree_setting {
  display: inline-block;
  background-color: #f2f5f6;
  vertical-align:top;
  min-width: 25%;
  box-sizing: border-box;
  margin-left: 20px;
}
</style>
